export const interactionModeExecutedAttributes = (
	interactionModeExecuted?: string,
): { interactionModeExecuted?: string } =>
	interactionModeExecuted ? { interactionModeExecuted } : {};
